import styled, { css } from "styled-components";
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";

export const Container = styled.div`
  padding: 16px 0;
  background-color: ${({ theme }) => theme.colors.gray_light};
  position: sticky;
  top: 60px;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  box-shadow: 0px 1px 10px -5px ${({ theme }) => theme.colors.box_shadow};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    top: 48px;
    padding: 12px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 10px 0;
  }
`;

export const List = styled.ul`
  display: flex;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  text-align: center;
`;

const defaultLink = css`
  font-size: 1.4rem;
  display: inline-block;
  padding: 4px 8px 4px 8px;
  font-weight: 600;
  margin: 0 36px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  &.active,
  &.hover {
    color: ${({ theme }) => theme.colors.purple};
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.2rem;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0 12px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 1rem;
    margin: 0 8px;
  }
`;

export const ListLink = styled(Link)`
  ${defaultLink}
`;

export const StyledAnchorLink = styled(AnchorLink)`
  ${defaultLink}
`;
